var $eefb5d3136039eaf$exports = {};
class $eefb5d3136039eaf$var$FileDrop extends HTMLElement {
    connectedCallback() {
        this.depth = 0;
        this.addEventListener("dragenter", this.onEnter);
        this.addEventListener("dragover", this.onOver);
        this.addEventListener("dragleave", this.onLeave);
        this.addEventListener("drop", this.onDrop);
    }
    disconnectedCallback() {
        this.removeEventListener("dragenter", this.onEnter);
        this.removeEventListener("dragover", this.onOver);
        this.removeEventListener("dragleave", this.onLeave);
        this.removeEventListener("drop", this.onDrop);
    }
    usable() {
        return this.hasAttribute("droppable");
    }
    onEnter = (event)=>{
        if (!this.usable()) return;
        event.preventDefault();
        this.depth += 1;
        this.setAttribute("dragging", "");
    };
    onOver = (event)=>{
        if (!this.usable()) return;
        event.preventDefault();
    };
    onLeave = ()=>{
        this.depth = Math.max(0, this.depth - 1);
        if (this.depth === 0) this.removeAttribute("dragging");
    };
    onDrop = (event)=>{
        this.depth = 0;
        this.removeAttribute("dragging");
        if (!this.usable()) return;
        event.preventDefault();
        const transfer = event.dataTransfer;
        if (!transfer) return;
        // webkitGetAsEntry must be read synchronously, before any await:
        // the DataTransfer is emptied once this handler returns.
        const entries = [
            ...transfer.items
        ].filter((item)=>item.kind === "file").map((item)=>item.webkitGetAsEntry && item.webkitGetAsEntry()).filter(Boolean);
        if (entries.length === 0) {
            this.emit([
                ...transfer.files
            ].map((file)=>({
                    file: file,
                    path: file.webkitRelativePath || file.name
                })));
            return;
        }
        $eefb5d3136039eaf$var$collectFiles(entries).then((files)=>this.emit(files));
    };
    // Each entry is { file, path }, where path is the folder-relative path.
    emit(files) {
        this.flashIfRejected(files);
        this.dispatchEvent(new CustomEvent("filesdropped", {
            detail: {
                files: files
            }
        }));
    }
    // Visual feedback when a drop includes files the field doesn't accept.
    // Elm still does the real filtering; this only flags the rejection.
    flashIfRejected(files) {
        const accept = this.getAttribute("accept");
        if (!accept || files.length === 0) return;
        if (files.some(({ file: file })=>!$eefb5d3136039eaf$var$matchesAccept(file, accept))) {
            this.setAttribute("rejected", "");
            clearTimeout(this._rejectTimer);
            this._rejectTimer = setTimeout(()=>this.removeAttribute("rejected"), 1800);
        }
    }
}
function $eefb5d3136039eaf$var$matchesAccept(file, accept) {
    const tokens = accept.split(",").map((token)=>token.trim().toLowerCase()).filter(Boolean);
    if (tokens.length === 0) return true;
    const name = (file.name || "").toLowerCase();
    const type = (file.type || "").toLowerCase();
    return tokens.some((token)=>{
        if (token === "*" || token === "*/*") return true;
        if (token.startsWith(".")) return name.endsWith(token);
        if (token.endsWith("/*")) return type.startsWith(token.slice(0, -1));
        return type === token;
    });
}
function $eefb5d3136039eaf$var$collectFiles(entries) {
    return Promise.all(entries.map($eefb5d3136039eaf$var$walkEntry)).then((nested)=>nested.flat());
}
function $eefb5d3136039eaf$var$walkEntry(entry) {
    if (entry.isFile) return new Promise((resolve)=>{
        entry.file((file)=>resolve([
                {
                    file: file,
                    path: $eefb5d3136039eaf$var$cleanPath(entry.fullPath)
                }
            ]), ()=>resolve([]));
    });
    if (entry.isDirectory) return $eefb5d3136039eaf$var$readAllEntries(entry.createReader()).then($eefb5d3136039eaf$var$collectFiles);
    return Promise.resolve([]);
}
function $eefb5d3136039eaf$var$cleanPath(fullPath) {
    return fullPath.replace(/^\//, "");
}
// readEntries returns directory children in chunks; call until it returns none.
function $eefb5d3136039eaf$var$readAllEntries(reader, acc = []) {
    return new Promise((resolve)=>{
        reader.readEntries((batch)=>{
            if (batch.length === 0) resolve(acc);
            else resolve($eefb5d3136039eaf$var$readAllEntries(reader, acc.concat(batch)));
        }, ()=>resolve(acc));
    });
}
customElements.define("file-drop", $eefb5d3136039eaf$var$FileDrop);


//# sourceMappingURL=provider-portal.53bb3219.js.map
